export default {
  noUnderline: 'no-underline',
  gridView: {
    card:
      'w-6/12 md:w-4/12 mt-30 pt-20 relative text-center pb-30 border-r md:px-15 flex flex-col',
    cardMedia: 'cursor-pointer m-auto',
    media: 'product-card-media mb-20',
    cardContent: 'w-full flex-grow flex-no-shrink flex-basis',
    cardContent1: 'flex-grow flex flex-col',
    headerWrapper: ' pl-10 pr-10 mb-10',
    headerWrapper1: 'flex-grow',
    headerText: 'font-sans-bold text-sm text-black leading-19 ',
    descriptionText: 'font-sans-roma text-sm mb-10 leading-19',
    button: 'font-sans-bold text-sm btn btn-light text-black',
    rating: 'text-grey font-sans-roma text-sm text-center',
    ratingWrapper: 'cursor-pointer text-center mb-15',
    ratingWrapper1: 'cursor-pointer text-center',
    ratingCount: 'pl-1 inline-block align-middle grey-darkest pb-1',
    cardActions: 'w-full absolute bottom-0 -pin-b15 md:pr-25 pb-10',
    cardActions1: 'w-full',
    ctaWrapper: 'btn btn-light btn-checkbox mt-10',
    label: 'text-sm font-sans-medium text-black inline-block align-middle',
    compareButton: 'ml-2 cursor-pointer',
    'secondary-button': 'btn btn-secondary',
    'solid-button': 'btn btn-solid',
    'button-wrapper': 'pt-10',
  },
  listView: {
    card: 'bg-white flex flex-row w-full relative border-b py-15 pb-10 px-15',
    cardMedia: ' md:w-4/12 w-6/12 cursor-pointer text-center',
    media: 'product-card-media',
    cardContent: 'md:w-8/12 w-6/12',
    cardContent1: 'md:w-8/12 w-6/12',
    headerWrapper: 'mb-10',
    headerText: 'font-sans-bold text-sm text-black leading-19',
    descriptionText: 'font-sans-roma text-sm mb-10 leading-19',
    button: 'font-sans-bold text-sm btn btn-light text-black',
    rating: 'text-grey font-sans-roma text-sm',
    ratingWrapper: 'cursor-pointer',
    ratingCount: 'px-3 inline-block align-middle grey-darkest pb-15',
    cardActions: 'relative w-full',
    ctaWrapper: 'btn btn-light btn-checkbox mt-10',
    label: 'text-sm font-sans-medium text-black inline-block align-top',
    compareButton: 'ml-2 cursor-pointer',
    'solid-button': 'btn btn-solid',
    'secondary-button': 'btn btn-secondary',
    'button-wrapper': 'pt-10',
  },
  ListingCard: {
    card:
      'product-card sm:w-44p mdp:w-30p md:w-30p flex-col justify-around text-center lg:mx-15 sm:mb-20 md:mb-30 sm:mx-8 md:px-0 prod-img relative h-400 mdp:h-450 md:h-450 lg:h-430',
    mediaWrapper: '',
    cardMedia:
      'w-auto sm:w-auto sm:h-160 mdp:w-auto mdp:h-200 md:w-auto md:h-200 lg:h-200 lg:w-auto mx-auto md:my-16 sm:my-16',
    contentWrapper: 'flex flex-col justify-end h-full',
    cardContent:
      'pt-1 tracking-1 sm:text-sm md:text-base leading-normal font-light sm:pb-10 md:pb-0',
    heading:
      'sm:text-18 md:text-20 font-BebasNeueRegular text-black pb-6 md:mt-16 sm:mt-10 lg:min-h-70 md:min-h-70 sm:min-h-90',
    cardActions: 'px-6 py-1',
    header:
      'font-sans-bold block  text-black text-15 leading-normal pt-2 pb-2 pr-' +
      '4 pl-4',
    description:
      'font-BebasNeueRegular text-grey sm:text-14 md:text-16 sm:pt-0 md:pt-0 md:mb-5 productcarddesc',
    componentBox: 'component-box w-full',
    button: [
      'btn-primary font-sans-bold mb-15 text-center',
      'btn-secondary font-sans-bold text-center',
    ],
    buttonContainer: 'w-full',
    ratingWrapper: 'flex flex-wrap',
    ratingTextCount:
      'text-grey md:text-sm sm:text-xs inline-block items-center -mt-2px ml-5 leading-normal font-thin',
  },
  buyNowBtnWrapper: 'buyNowBtnWrapper',
  prodCardBtnDiv: 'try-now-btn text-center z-1 bg-white inline-block',
};
